import { render, staticRenderFns } from "./alldatasflow.vue?vue&type=template&id=1d864a37&scoped=true&"
import script from "./alldatasflow.vue?vue&type=script&lang=js&"
export * from "./alldatasflow.vue?vue&type=script&lang=js&"
import style0 from "./alldatasflow.vue?vue&type=style&index=0&id=1d864a37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d864a37",
  null
  
)

export default component.exports